// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SQH7","field":"styles_field__3PZr4","fieldCol":"styles_fieldCol__ZMAcs","diffCol":"styles_diffCol__2Qqvv","diff":"styles_diff__2UJWX"};